import i18n from 'config/i18n';
import dayjs, { Dayjs } from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import * as yup from 'yup';

import { stringToFloat } from 'utils/misc';
import { getLocale } from 'utils/date';

dayjs.extend(minMax);

const addRouteSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.object({
    organizationalUnit: yup.mixed().notRequired(),
    code: yup
      .string()
      .required(t('validationFieldRequired', { name: 'route-nr' })),
    start: yup
      .mixed<Dayjs>()
      .test(
        'dayjs-valid',
        () => t('invalidDate'),
        (v) => (v ? v.isValid() : false)
      )
      .required(),
    endTime: yup.string().default(null).nullable().notRequired(),
    hourDuration: yup
      .number()
      .default(0)
      .transform(stringToFloat)
      .typeError(t('enterAValidNumericValue'))
      .min(0, t('validationMinNumber', { name: t('duration'), number: 0 }))
      .max(23, t('validationMaxNumber', { name: t('duration'), number: 23 }))
      .required(t('validationFieldRequired', { name: t('duration') })),
    minuteDuration: yup
      .number()
      .default(0)
      .transform(stringToFloat)
      .typeError(t('enterAValidNumericValue'))
      .min(0, t('validationMinNumber', { name: t('duration'), number: 0 }))
      .max(59, t('validationMaxNumber', { name: t('duration'), number: 59 }))
      .required(t('validationFieldRequired', { name: t('duration') }))
      .when(['hourDuration'], {
        is: (hourDuration?: number) => hourDuration === 0,
        then: yup
          .number()
          .min(1, t('activityPlanning.minimumTotalDuration', { minutes: 1 }))
      }),
    description: yup.string().notRequired()
  });
};

export default addRouteSchema;
